import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';
import { Salary } from '@app/models/employee/salary.model';
import { Translatable } from '@app/types/translatable.type';

export class EmployeeCompensationTypeColumn extends Column {
    title = 'table.compensationHistory.compensationType';
    property = 'frequencyLabel';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(salary: Salary): Translatable {
        if (salary.frequency === 'year') {
            return 'table.compensationHistory.yearly';
        }
        return 'table.compensationHistory.hourly';
    }
}
